/**
 * 客户端 HTTP 通信模块
 * 作为 WebSocket 失败时的备用方案
 */

import { showClientErrorDialog } from '@/assets/js/clientErrorDialog'
import { Base64 } from 'js-base64'

const clientHttpUrl = 'http://127.0.0.1:36716?data='
const clientHttpsUrl = 'https://localhost.easysign.cn:36717?data='

/**
 * 获取当前协议对应的客户端 URL
 */
function getClientUrl() {
  return document.location.protocol === 'https:' ? clientHttpsUrl : clientHttpUrl
}

/**
 * 检查是否安装与启动了客户端
 */
export function checkClient() {
  var clientUrl = getClientUrl()
  var param = { command: 114, code: 10, parameter: '' }
  var data = JSON.stringify(param)
  data = Base64.encode(data)
  var xtPath = clientUrl + data + '&callback=success_jsonpCallback'
  jQuery.support.cors = true
  return new Promise((resolve, reject) => {
    $.ajax({
      url: xtPath,
      type: 'GET',
      success: (res) => {
        res = res.replace('(', '').replace(')', '').replace(';', '')
        res = JSON.parse(res)
        resolve(res)
      },
      error: () => {
        showClientErrorDialog()
        reject()
      }
    })
  })
}

/**
 * 检查是否安装与启动了客户端（标准检查）
 */
export function standCheckClient() {
  var clientUrl = getClientUrl()
  var param = { command: 113, code: 11, parameter: '' }
  var data = JSON.stringify(param)
  data = Base64.encode(data)
  var xtPath = clientUrl + data + '&callback=success_jsonpCallback'
  jQuery.support.cors = true
  return new Promise((resolve, reject) => {
    $.ajax({
      url: xtPath,
      type: 'GET',
      success: (res) => {
        resolve(res)
      },
      error: () => {
        showClientErrorDialog()
        reject()
      }
    })
  })
}

/**
 * 调用客户端接口（GET）
 * @param {Object} param - 请求参数 { command, code, parameter }
 */
export function clientApi(param) {
  var clientUrl = getClientUrl()
  var data = JSON.stringify(param)
  data = Base64.encode(data)
  var xtPath = clientUrl + data
  jQuery.support.cors = true
  return new Promise((resolve, reject) => {
    $.ajax({
      url: xtPath,
      type: 'GET',
      timeout: 60000,
      dataType: 'jsonp',
      jsonp: 'callback',
      jsonpCallback: 'success_jsonpCallback' + Math.floor(Math.random() * 100000),
      success: (res) => {
        if (res.error == '0') {
          resolve(res)
        } else {
          reject(res.msg)
        }
      },
      error: (jqXHR, textStatus) => {
        if (textStatus == 'timeout' && jqXHR.readyState < 4) {
          jqXHR.abort()
          reject('请求超时，请确认是否启动客户端！')
        } else {
          showClientErrorDialog()
          reject()
        }
      }
    })
  })
}

/**
 * 调用客户端接口（POST）
 * @param {Object} param - 请求参数 { command, code, parameter }
 */
export function clientApiPost(param) {
  var clientUrl = getClientUrl()
  var data = JSON.stringify(param)
  data = Base64.encode(data)
  jQuery.support.cors = true
  return new Promise((resolve, reject) => {
    $.ajax({
      type: 'post',
      cache: false,
      dataType: 'json',
      data: { dataStr: data },
      url: clientUrl.replace('?data=', ''),
      success: (res) => {
        if (res.error == '0') {
          resolve(res)
        } else {
          reject(res.msg)
        }
      },
      error: (jqXHR, textStatus) => {
        if (textStatus == 'timeout' && jqXHR.readyState < 4) {
          jqXHR.abort()
          reject('请求超时，请确认是否启动客户端！')
        } else {
          showClientErrorDialog()
          reject()
        }
      }
    })
  })
}



// WEBPACK FOOTER //
// ./src/assets/js/clientCommunication.js